import { Company } from '@homepage/types/company';
import { prettyPhone } from '@shared/utils/phone';

import { Location } from './locations';

export const COMPANY: Company = {
  contact: {
    img: {
      alt: 'Waldemar Lotz, Co-Founder und Ausbilder',
      src: '/img/profile-waldemar-lotz-250.jpg',
    },
    text: 'Waldemar, Co-Founder und Ausbilder',
  },
  email: 'KriegerSein-Trier@web.de',
  isHQ: false,
  name: 'Systema Akademie Trier',
  phone: '+4915238212486',
  phoneText: prettyPhone('+4915238212486'),
  schedule: [
    { location: Location.Druckwerk, time: 'Mittwochs, 18:00 - 20:00 Uhr' },
    { location: Location.Druckwerk, time: 'Freitags, 18:30 - 20:30 Uhr' },
  ],
  trialFee: 10,
};
